/* eslint-disable max-len */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import PayModal from './PayModal'
import PlanSelectModal from './PlanSelectModal'

import {
  getPlanSelectedFlag,
  getUpdatePaymentSettingsFlag,
  getSwitchToYearlyFlag,
} from '../../../ducks/trialWarning'

const FORM_NAME = 'trialModalSignup'

const validate = values => {
  const error = {}

  if (!values.name) {
    error.name = 'Please provide your name'
  }

  if (!values.address_country) {
    error.address_country = 'Please select your country from the dropdown'
  }

  if (!values.address_line1) {
    error.address_line1 = 'Please provide the first line of your address'
  }

  if (!values.address_city) {
    error.address_city = 'Please provide your city name'
  }

  if (!values.address_zip) {
    error.address_zip = 'Please provide your postal code'
  }

  return error
}

class SignupForm extends Component {
  renderSub() {
    const {
      onCancel,
      submitting,
      submitText,
      error,
      metrics,
      datasource,
      hideStorage,
      hideFreeTier,
      title,
      onDowngrade,
      updatePaymentSettings,
      handleSubmit,
      planSelected,
      onClickBackChangePlan,
      switchToYearly,
      organizationId,
      couponCode,
    } = this.props

    if (planSelected || updatePaymentSettings || switchToYearly) {
      return (
        <PayModal
          submitting={submitting}
          submitText={submitText}
          error={error}
          onCancel={onCancel}
          onSubmit={handleSubmit}
          onClickBackChangePlan={onClickBackChangePlan}
          couponCode={couponCode}
          organizationId={organizationId}
        />
      )
    }

    return (
      <PlanSelectModal
        onCancel={onCancel}
        metrics={metrics}
        datasource={datasource}
        hideFreeTier={hideFreeTier}
        hideStorage={hideStorage}
        title={title}
        onDowngrade={onDowngrade}
        onClickBackChangePlan={onClickBackChangePlan}
        organizationId={organizationId}
      />
    )
  }

  render() {
    const { handleSubmit } = this.props

    return <form onSubmit={handleSubmit}>{this.renderSub()}</form>
  }
}

const mapStateToProps = state => {
  const selector = formValueSelector(FORM_NAME)
  const couponCode = selector(state, 'coupon')

  return {
    updatePaymentSettings: getUpdatePaymentSettingsFlag(state),
    switchToYearly: getSwitchToYearlyFlag(state),
    planSelected: getPlanSelectedFlag(state),
    couponCode,
  }
}

const connected = connect(mapStateToProps)(SignupForm)
export default reduxForm({ validate, form: FORM_NAME })(withRouter(connected))
